export default {
    methods: {
        crearFecha(format, date = null) {
            if (date) {
                let fechaEU = date.split('/');
                if (fechaEU.length === 3) {
                    date = `${fechaEU[2]}-${fechaEU[1]}-${fechaEU[0]}`;
                }
            }
            switch (format) {
                case 'Y-m-d':
                    return date == null ? new Date().toISOString().substr(0, 10) : new Date(date).toISOString().substr(0, 10)
                case 'd/m/Y':
                    return date == null ? this.formatDate(new Date().toISOString().substr(0, 10)) : this.formatDate(new Date(date).toISOString().substr(0, 10))
                default:
                    return date == null ? new Date() : new Date(date);
            }
        },
        formatearFecha(fecha) {
            // devuelve una fecha tipo: 2020-08-06T17:24:13.000000Z en formato: 06/08/2020 19:24
            let formato = {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }
            let fechaFormateada = new Date(fecha).toLocaleDateString('es-ES', formato);
            return fechaFormateada;
        },
        formatearHora(fecha) {
            // convierte una fecha tipo: 2020-08-06T17:24:13.000000Z en una hora en formato: 17:24
            return fecha.toLocaleTimeString('es-ES', {
                hour12: false,
                hour: '2-digit',
                minute: '2-digit'
            });
        },
        formatDate(fecha) { //devuelve una fecha tipo: YYYY-MM-DD en formato: DD/MM/YYYY
            if (fecha) {
                const [year, month, day] = fecha.split('-');
                return `${day}/${month}/${year}`;
            }
            return null
        },
        parseDate(fecha) { //devuelve una fecha tipo: DD/MM/YYYY en formato: YYYY-MM-DD
            if (fecha) {
                const [day, month, year] = fecha.split('/');
                return `${year}-${month}-${day}`;
            }
            return null;
        },
    },

}